var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.59 34.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-crm1 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-crm1, .cls-crm2 {\r\n        fill: none;\r\n        stroke: currentcolor;\r\n      } \r\n\r\n      .cls-crm2 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-crm3 {\r\n        fill: currentcolor;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-crm2",
    cx: 12.96,
    cy: 7.57,
    rx: 6.14,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-crm1",
    d: "M16.87,17.61h-7.82c-4.72,0-8.55,3.83-8.55,8.55v6.47c0,.8.65,1.45,1.45,1.45h22.21c.8,0,1.45-.65,1.45-1.45v-3.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-crm1",
    x1: 19.84,
    y1: 27.1,
    x2: 19.84,
    y2: 34.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-crm1",
    x1: 5.8,
    y1: 27.1,
    x2: 5.8,
    y2: 33.79
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-crm2",
    cx: 27.1,
    cy: 17.32,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.13,14.45c.17-.17.27-.41.27-.66s-.1-.49-.27-.66l-.51-.51c-.17-.17-.41-.27-.66-.27s-.49.1-.66.27l-6.68,6.68-1.15,2.62v.35h6.41c.26,0,.48-.22.48-.48s-.22-.48-.48-.48h-1.12c-.09,0-.16-.07-.16-.16s.07-.16.16-.16h3.68v-.32h-3.68c-.26,0-.48.22-.48.48s.22.48.48.48h1.12c.09,0,.16.07.16.16s-.07.16-.16.16h-5.32l1.89-.83,6.68-6.68ZM30.34,15.8l-.25.25-1.38-1.38.25-.25,1.38,1.38ZM29.19,14.19l.25-.25,1.38,1.38-.25.25-1.38-1.38ZM28.82,15.24l-4.5,4.5-.33-.33,4.5-4.5.33.33ZM29.04,15.46l.25.25-4.5,4.5-.25-.25,4.5-4.5ZM29.52,15.94l.33.33-4.5,4.5-.33-.33,4.5-4.5ZM30.53,12.85c.11-.11.27-.18.43-.18s.32.07.43.18l.51.51c.11.11.18.27.18.43s-.07.32-.18.43l-.86.86-1.38-1.38.86-.86ZM23.81,19.68l1.27,1.27-1.24.54-.57-.57.54-1.24ZM23.13,21.24l.39.39-.7.31.31-.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/CRM.3108ab73e571652769e9520535099558.svg";
export { ForwardRef as ReactComponent };